import { ELEVATE_UPLOAD_PDFs } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';

interface UploadPdfResponse {
  success: boolean;
  message?: string;
}

interface PdfUploadPayload {
  s3_url: string;
  filename: string;
  pdf_type: string;
}

const uploadPdfApi = async (
  id: string,
  pdfs: PdfUploadPayload | PdfUploadPayload[]
): Promise<UploadPdfResponse> => {
  try {
    const response = await makeAuthenticatedRequest(ELEVATE_UPLOAD_PDFs(id), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(pdfs),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.message || `HTTP error! status: ${response.status}`
      );
    }

    return result;
  } catch (error) {
    console.error('Upload pdf failed:', error);
    throw error;
  }
};

export { uploadPdfApi, type UploadPdfResponse };
